import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Input } from "@shadcn-in-nx/ui/input";

function TablePagination({
    currentPage,
    totalPages,
    totalRecords,
    pageInput,
    isLoading,
    onPageChange,
    onPageInputChange,
    onPageInputSubmit,
    onPageInputKeyDown,
}) {
    if (totalPages <= 1) return null;

    return (
        <div className="flex items-center justify-between px-4 py-3 border-t border-border bg-card">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <span>Showing page {currentPage} of {totalPages}</span>
                <span className="text-muted-foreground/50">&bull;</span>
                <span>{totalRecords} total record{totalRecords !== 1 ? "s" : ""}</span>
            </div>
            <div className="flex items-center gap-2">
                <Button variant="outline" size="sm" onClick={() => onPageChange(1)} disabled={currentPage === 1 || isLoading}>
                    First
                </Button>
                <Button variant="outline" size="sm" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1 || isLoading}>
                    Previous
                </Button>
                <div className="flex items-center gap-2">
                    <span className="text-sm text-muted-foreground">Page</span>
                    <Input
                        type="number"
                        min="1"
                        max={totalPages}
                        value={pageInput}
                        onChange={onPageInputChange}
                        onBlur={onPageInputSubmit}
                        onKeyDown={onPageInputKeyDown}
                        className="w-16 h-8 text-center"
                        disabled={isLoading}
                    />
                    <span className="text-sm text-muted-foreground">of {totalPages}</span>
                </div>
                <Button variant="outline" size="sm" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= totalPages || isLoading}>
                    Next
                </Button>
                <Button variant="outline" size="sm" onClick={() => onPageChange(totalPages)} disabled={currentPage >= totalPages || isLoading}>
                    Last
                </Button>
            </div>
        </div>
    );
}

export default React.memo(TablePagination);
